import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'swiper/css/swiper.css'
import store from './vuex/store'
import App from './App.vue'
import router from './router/index'
import request from './api'
import utils from './utils/index'
import './utils/plus'
import MyShopCard from './components/MyShopCard'
import MyShopList from './components/MyShopList'
import pList from './components/pList'
import search from './components/search'
import shopInquire from './components/shopInquire'
import searchPlist from './components/searchPlist'

Vue.use(Vant)
Vue.config.productionTip = false
Vue.component('MyShopCard', MyShopCard)
Vue.component('MyShopList', MyShopList)
Vue.component('pList', pList)
Vue.component('search', search)
Vue.component('shopInquire', shopInquire)
Vue.component('searchPlist', searchPlist)
Vue.prototype.$request = request
Vue.prototype.$utils = utils

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
